import type { NoticeItemRaw } from "../types";

/** 本会话已上报 markPopupShown 的 id（防止 sync 完成前重复弹同一条） */
const locallyPopupShownIds = new Set<string>();

/** 列表未读：read=false 为未读（不用 pushed） */
export function isUserNoticeRead(item: Pick<NoticeItemRaw, "read">): boolean {
  return item.read === true;
}

/** 是否需要弹窗：openDialogTips && !pushed */
export function shouldShowUserNoticePopup(
  item: Pick<NoticeItemRaw, "openDialogTips" | "pushed">
): boolean {
  return item.openDialogTips === true && item.pushed === false;
}

export function rememberNoticePopupShown(id: string | number): void {
  locallyPopupShownIds.add(String(id));
}

export function forgetNoticePopupShown(id: string | number): void {
  locallyPopupShownIds.delete(String(id));
}

export function isNoticePopupShownLocally(id: string | number): boolean {
  return locallyPopupShownIds.has(String(id));
}

/** 服务端已 pushed 时清理本地记录 */
export function pruneRememberedPopupShown(items: NoticeItemRaw[]): void {
  for (const item of items) {
    if (item.pushed) {
      locallyPopupShownIds.delete(String(item.id));
    }
  }
}

export function pickNextUserNoticePopup(
  items: NoticeItemRaw[]
): NoticeItemRaw | null {
  return (
    items.find(
      item =>
        shouldShowUserNoticePopup(item) && !isNoticePopupShownLocally(item.id)
    ) ?? null
  );
}
